import { Component, OnInit } from '@angular/core';
import { FeatureFlagsService } from '../../Common/FeatureFlags/feature-flags-service';
import { ProcessInvoiceComponent } from './invoice.component';
import { ProcessInvoiceOldComponent } from './Invoice-Old/invoice.component';

@Component({
    selector: 'app-invoice-redirect',
    template: `
        @if (enableImprovedInvoiceSavings) {
            <invoice></invoice>
        } @else {
            <invoice-old></invoice-old>
        }
    `,
    imports: [ProcessInvoiceComponent, ProcessInvoiceOldComponent],
})
export class InvoiceRedirectComponent implements OnInit {
    constructor(private readonly _featureFlagsService: FeatureFlagsService) {}

    enableImprovedInvoiceSavings: boolean;

    ngOnInit() {
        this.enableImprovedInvoiceSavings = this._featureFlagsService.featureFlags.enableImprovedInvoiceSavings;
    }
}
